import { useEffect } from 'react'
import Hero from './components/Home/Hero'
import Projects from './components/Home/Projects'
import About from './components/Home/About'
import Resume from './components/Home/Resume'

const Home = () => {
    useEffect(() => {
        if (!('IntersectionObserver' in window)) return

        const elements = document.querySelectorAll('[data-reveal]')
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(({ target, isIntersecting }) => {
                    if (!isIntersecting) return
                    target.classList.remove('reveal-pending')
                    target.classList.add('reveal-visible')
                    observer.unobserve(target)
                })
            },
            { threshold: 0.08, rootMargin: '0px 0px 32px 0px' }
        )

        elements.forEach((element) => {
            if (element.getBoundingClientRect().top > window.innerHeight * 0.9) {
                element.classList.add('reveal-pending')
            }
            observer.observe(element)
        })

        return () => observer.disconnect()
    }, [])

    return (
        <main id="main-content">
            <Hero />
            <Projects />
            <About />
            <Resume />
        </main>
    )
}

export default Home
